export const setKendoMessages = (messages) => {
	if (kendo.ui.FlatColorPicker) {
		kendo.ui.FlatColorPicker.prototype.options.messages =
			$.extend(true, kendo.ui.FlatColorPicker.prototype.options.messages, messages.FlatColorPicker);
	}

	/* ColorPicker messages */

	if (kendo.ui.ColorPicker) {
		kendo.ui.ColorPicker.prototype.options.messages =
			$.extend(true, kendo.ui.ColorPicker.prototype.options.messages, messages.ColorPicker);
	}

	/* ColumnMenu messages */

	if (kendo.ui.ColumnMenu) {
		kendo.ui.ColumnMenu.prototype.options.messages =
			$.extend(true, kendo.ui.ColumnMenu.prototype.options.messages, messages.ColumnMenu);
	}

	/* DateRangePicker messages */

	if (kendo.ui.DateRangePicker) {
		kendo.ui.DateRangePicker.prototype.options.messages =
			$.extend(true, kendo.ui.DateRangePicker.prototype.options.messages, messages.DateRangePicker);
	}

	/* Editor messages */

	if (kendo.ui.Editor) {
		kendo.ui.Editor.prototype.options.messages =
			$.extend(true, kendo.ui.Editor.prototype.options.messages, messages.Editor);
	}

	/* FileBrowser messages */

	if (kendo.ui.FileBrowser) {
		kendo.ui.FileBrowser.prototype.options.messages =
			$.extend(true, kendo.ui.FileBrowser.prototype.options.messages, messages.FileBrowser);
	}

	/* FilterCell messages */

	if (kendo.ui.FilterCell) {
		kendo.ui.FilterCell.prototype.options.messages =
			$.extend(true, kendo.ui.FilterCell.prototype.options.messages, messages.FilterCell);
	}

	/* FilterCell operators */

	if (kendo.ui.FilterCell) {
		kendo.ui.FilterCell.prototype.options.operators =
			$.extend(true, kendo.ui.FilterCell.prototype.options.operators, messages.FilterCellComparison);
	}

	/* FilterMenu messages */

	if (kendo.ui.FilterMenu) {
		kendo.ui.FilterMenu.prototype.options.messages =
			$.extend(true, kendo.ui.FilterMenu.prototype.options.messages, messages.FilterMenu);
	}

	/* FilterMenu operator messages */

	if (kendo.ui.FilterMenu) {
		kendo.ui.FilterMenu.prototype.options.operators =
			$.extend(true, kendo.ui.FilterMenu.prototype.options.operators, messages.FilterMenuComparison);
	}

	/* FilterMultiCheck messages */

	if (kendo.ui.FilterMultiCheck) {
		kendo.ui.FilterMultiCheck.prototype.options.messages =
			$.extend(true, kendo.ui.FilterMultiCheck.prototype.options.messages, messages.FilterMultiCheck);
	}

	/* Gantt messages */

	if (kendo.ui.Gantt) {
		kendo.ui.Gantt.prototype.options.messages =
			$.extend(true, kendo.ui.Gantt.prototype.options.messages, messages.Gantt);
	}

	/* Grid messages */

	if (kendo.ui.Grid) {
		kendo.ui.Grid.prototype.options.messages =
			$.extend(true, kendo.ui.Grid.prototype.options.messages, messages.Grid);
	}

	/* Groupable messages */

	if (kendo.ui.Groupable) {
		kendo.ui.Groupable.prototype.options.messages =
			$.extend(true, kendo.ui.Groupable.prototype.options.messages, messages.Groupable);
	}

	/* NumericTextBox messages */

	if (kendo.ui.NumericTextBox) {
		kendo.ui.NumericTextBox.prototype.options =
			$.extend(true, kendo.ui.NumericTextBox.prototype.options, messages.NumericTextBox);
	}

	/* MediaPlayer messages */

	if (kendo.ui.MediaPlayer) {
		kendo.ui.MediaPlayer.prototype.options.messages =
			$.extend(true, kendo.ui.MediaPlayer.prototype.options.messages, messages.MediaPlayer);
	}

	/* Pager messages */

	if (kendo.ui.Pager) {
		kendo.ui.Pager.prototype.options.messages =
			$.extend(true, kendo.ui.Pager.prototype.options.messages, messages.Pager);
	}

	/* TreeListPager messages */

	if (kendo.ui.TreeListPager) {
		kendo.ui.TreeListPager.prototype.options.messages =
			$.extend(true, kendo.ui.TreeListPager.prototype.options.messages, messages.TreeListPager);
	}

	/* PivotGrid messages */

	if (kendo.ui.PivotGrid) {
		kendo.ui.PivotGrid.prototype.options.messages =
			$.extend(true, kendo.ui.PivotGrid.prototype.options.messages, messages.PivotGrid);
	}

	/* PivotFieldMenu messages */

	if (kendo.ui.PivotFieldMenu) {
		kendo.ui.PivotFieldMenu.prototype.options.messages =
			$.extend(true, kendo.ui.PivotFieldMenu.prototype.options.messages, messages.PivotFieldMenu);
	}

	/* RecurrenceEditor messages */

	if (kendo.ui.RecurrenceEditor) {
		kendo.ui.RecurrenceEditor.prototype.options.messages =
			$.extend(true, kendo.ui.RecurrenceEditor.prototype.options.messages, messages.RecurrenceEditor);
	}

	/* MobileRecurrenceEditor messages */

	if (kendo.ui.MobileRecurrenceEditor) {
		kendo.ui.MobileRecurrenceEditor.prototype.options.messages =
			$.extend(true, kendo.ui.MobileRecurrenceEditor.prototype.options.messages, kendo.ui.RecurrenceEditor.prototype.options.messages, messages.MobileRecurrenceEditor);
	}

	/* Scheduler messages */

	if (kendo.ui.Scheduler) {
		kendo.ui.Scheduler.prototype.options.messages =
			$.extend(true, kendo.ui.Scheduler.prototype.options.messages, messages.Scheduler);
	}

	/* Spreadsheet messages */

	if (kendo.spreadsheet && kendo.spreadsheet.messages.borderPalette) {
		kendo.spreadsheet.messages.borderPalette =
			$.extend(true, kendo.spreadsheet.messages.borderPalette, messages.SpreadsheetBorderPalette);
	}

	if (kendo.spreadsheet && kendo.spreadsheet.messages.dialogs) {
		kendo.spreadsheet.messages.dialogs =
			$.extend(true, kendo.spreadsheet.messages.dialogs, messages.SpreadsheetDialogs);
	}

	if (kendo.spreadsheet && kendo.spreadsheet.messages.filterMenu) {
		kendo.spreadsheet.messages.filterMenu =
			$.extend(true, kendo.spreadsheet.messages.filterMenu, messages.SpreadsheetFilterMenu);
	}

	if (kendo.spreadsheet && kendo.spreadsheet.messages.colorPicker) {
		kendo.spreadsheet.messages.colorPicker =
			$.extend(true, kendo.spreadsheet.messages.colorPicker, messages.SpreadsheetColorPicker);
	}

	if (kendo.spreadsheet && kendo.spreadsheet.messages.toolbar) {
		kendo.spreadsheet.messages.toolbar =
			$.extend(true, kendo.spreadsheet.messages.toolbar, messages.SpreadsheetToolbar);
	}

	if (kendo.spreadsheet && kendo.spreadsheet.messages.view) {
		kendo.spreadsheet.messages.view =
			$.extend(true, kendo.spreadsheet.messages.view, messages.SpreadsheetView);
	}

	/* Slider messages */

	if (kendo.ui.Slider) {
		kendo.ui.Slider.prototype.options =
			$.extend(true, kendo.ui.Slider.prototype.options, messages.Slider);
	}

	/* TreeList messages */

	if (kendo.ui.TreeList) {
		kendo.ui.TreeList.prototype.options.messages =
			$.extend(true, kendo.ui.TreeList.prototype.options.messages, messages.TreeList);
	}

	/* TreeView messages */

	if (kendo.ui.TreeView) {
		kendo.ui.TreeView.prototype.options.messages =
			$.extend(true, kendo.ui.TreeView.prototype.options.messages, messages.TreeView);
	}

	/* Upload messages */

	if (kendo.ui.Upload) {
		kendo.ui.Upload.prototype.options.localization =
			$.extend(true, kendo.ui.Upload.prototype.options.localization, messages.Upload);
	}

	/* Validator messages */

	if (kendo.ui.Validator) {
		kendo.ui.Validator.prototype.options.messages =
			$.extend(true, kendo.ui.Validator.prototype.options.messages, messages.Validator);
	}

	/* Dialog */

	if (kendo.ui.Dialog) {
		kendo.ui.Dialog.prototype.options.messages =
			$.extend(true, kendo.ui.Dialog.prototype.options.localization, messages.Dialog);
	}

	/* Alert */

	if (kendo.ui.Alert) {
		kendo.ui.Alert.prototype.options.messages =
			$.extend(true, kendo.ui.Alert.prototype.options.localization, messages.Alert);
	}

	/* Confirm */

	if (kendo.ui.Confirm) {
		kendo.ui.Confirm.prototype.options.messages =
			$.extend(true, kendo.ui.Confirm.prototype.options.localization, messages.Confirm);
	}

	/* Prompt */
	if (kendo.ui.Prompt) {
		kendo.ui.Prompt.prototype.options.messages =
			$.extend(true, kendo.ui.Prompt.prototype.options.localization, messages.Prompt);
	}

	/* List messages */

	if (kendo.ui.List) {
		kendo.ui.List.prototype.options.messages =
			$.extend(true, kendo.ui.List.prototype.options.messages, messages.List);
	}

	/* DropDownList messages */

	if (kendo.ui.DropDownList) {
		kendo.ui.DropDownList.prototype.options.messages =
			$.extend(true, kendo.ui.DropDownList.prototype.options.messages, kendo.ui.List.prototype.options.messages);
	}

	/* ComboBox messages */

	if (kendo.ui.ComboBox) {
		kendo.ui.ComboBox.prototype.options.messages =
			$.extend(true, kendo.ui.ComboBox.prototype.options.messages, kendo.ui.List.prototype.options.messages);
	}

	/* AutoComplete messages */

	if (kendo.ui.AutoComplete) {
		kendo.ui.AutoComplete.prototype.options.messages =
			$.extend(true, kendo.ui.AutoComplete.prototype.options.messages, kendo.ui.List.prototype.options.messages);
	}

	/* MultiColumnComboBox messages */

	if (kendo.ui.MultiColumnComboBox) {
		kendo.ui.MultiColumnComboBox.prototype.options.messages =
			$.extend(true, kendo.ui.MultiColumnComboBox.prototype.options.messages, kendo.ui.List.prototype.options.messages);
	}

	/* DropDownTree messages */

	if (kendo.ui.DropDownTree) {
		kendo.ui.DropDownTree.prototype.options.messages =
			$.extend(true, kendo.ui.DropDownTree.prototype.options.messages, messages.DropDownTree);
	}

	/* MultiSelect messages */

	if (kendo.ui.MultiSelect) {
		kendo.ui.MultiSelect.prototype.options.messages =
			$.extend(true, kendo.ui.MultiSelect.prototype.options.messages, messages.MultiSelect);
	}

	/* Chat messages */

	if (kendo.ui.Chat) {
		kendo.ui.Chat.prototype.options.messages =
			$.extend(true, kendo.ui.Chat.prototype.options.messages, messages.Chat);
	}

	/* Wizard messages */

	if (kendo.ui.Wizard) {
		kendo.ui.Wizard.prototype.options.messages =
			$.extend(true, kendo.ui.Wizard.prototype.options.messages, messages.Wizard);
	}


	/* PDFViewer messages */

	if (kendo.ui.PDFViewer) {
		kendo.ui.PDFViewer.prototype.options.messages =
			$.extend(true, kendo.ui.PDFViewer.prototype.options.messages, messages.PDFViewer);
	}
};

export const setKendoCulture = (locale, messages) => {
	let x = null;
	kendo.cultures[locale] = {
		name: locale,
		numberFormat: {
			pattern: getArray(messages.numberFormat.pattern, false, true, true),
			decimals: getVal(messages.numberFormat.decimals, true, true),
			",": getVal(messages.numberFormat.comma),
			".": getVal(messages.numberFormat.point),
			groupSize: getArray(messages.numberFormat.groupSize, true, true, true),
			percent: {
				pattern: getArray(messages.numberFormat.percent.pattern, false, true, true),
				decimals: getVal(messages.numberFormat.percent.decimals, true, true),
				",": getVal(messages.numberFormat.percent.comma),
				".": getVal(messages.numberFormat.percent.point),
				groupSize: getArray(messages.numberFormat.percent.groupSize, true, true, true),
				symbol: getVal(messages.numberFormat.percent.symbol),
			},
			currency: {
				name: getVal(messages.numberFormat.currency.name),
				abbr: getVal(messages.numberFormat.currency.abbr),
				pattern: getArray(messages.numberFormat.currency.pattern, false, true, true),
				decimals: getVal(messages.numberFormat.currency.decimals, true, true),
				",": getVal(messages.numberFormat.currency.comma),
				".": getVal(messages.numberFormat.currency.point),
				groupSize: getArray(messages.numberFormat.currency.groupSize, true, true, true),
				symbol: getVal(messages.numberFormat.currency.symbol),
			}
		},
		calendars: {
			standard: {
				days: {
					names: (x = messages.calendars.standard.days.names, [x.sunday, x.monday, x.tuesday, x.wednesday, x.thursday, x.friday, x.saturday]),
					namesAbbr: (x = messages.calendars.standard.days['names-abbreviated'], [x.sunday, x.monday, x.tuesday, x.wednesday, x.thursday, x.friday, x.saturday]),
					namesShort: (x = messages.calendars.standard.days['names-short'], [x.sunday, x.monday, x.tuesday, x.wednesday, x.thursday, x.friday, x.saturday]),
				},
				months: {
					names: (x=messages.calendars.standard.months.names,[x.january, x.february, x.march, x.april, x.may, x.june, x.july, x.august, x.september, x.october, x.november, x.december]),
					namesAbbr: (x=messages.calendars.standard.months['names-abbreviated'],[x.january, x.february, x.march, x.april, x.may, x.june, x.july, x.august, x.september, x.october, x.november, x.december]),
				},
				AM: getArray(messages.calendars.standard.AM, false, true, true),
				PM: getArray(messages.calendars.standard.PM, false, true, true),
				patterns: getObj(messages.calendars.standard.patterns, false, true),
				"/": getVal(messages.calendars.standard.slash),
				":": getVal(messages.calendars.standard.colon),
				firstDay: getVal(messages.calendars.standard.firstDay, true, true),
			}
		}
	};
	kendo.culture(locale);
};

/* UTILS */
const getArray = (obj, int, hidePrefix = true, sort = false) => {
	const arr = [];
	let keys = Object.keys(obj);
	if (sort) {
		keys.sort();
	}
	keys.forEach(key => {
		if (obj[key]) {
			let stringVal = obj[key];
			if (window._intlPrefix && hidePrefix) {
				stringVal = stringVal.replace(window._intlPrefix, '');
			}
			arr.push(int ? parseInt(stringVal) : stringVal);
		}
	});
	return arr;
};

const getVal = (str, int, hidePrefix) => {
	let stringVal = str;
	if (window._intlPrefix && hidePrefix) {
		stringVal = stringVal.replace(window._intlPrefix, '');
	}
	return int ? parseInt(stringVal) : stringVal;
};

const getObj = (obj, hidePrefix) => {
	Object.keys(obj).forEach(key => {
		if (obj[key] && typeof obj[key] === 'string') {
			if (window._intlPrefix && hidePrefix) {
				obj[key] = obj[key].replace(window._intlPrefix, '');
			}
		}
	});
	return obj;
};
